module.exports = __webpack_public_path__ + "static/media/chicago.9530a70d.jpg";